export default function StickyContainerDirective(module) {
    angular.module(module || 'app')
        .directive('stickyContainer', stickyContainer);
    
    function stickyContainer() {
        var directive = {
            restrict: 'A',
            require: {
                stickyManager: '?^^stickyManager'
            },
            bindToController: true,
            controller: controller,
            controllerAs: 'sc'
        };
        function controller($element, $timeout) {
            var ctrl = this;
            ctrl.getBottom = function () {
                return $element[0].getBoundingClientRect().bottom;
            };

            ctrl.scrollToTop = function () {
                $timeout(function () {
                    var offset = $element[0].getBoundingClientRect().top;
                    if (offset < 0) {
                        angular.element('html, body').animate({
                            scrollTop: '-=' + -(offset - (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint(1) : 0))
                        });
                    }
                });
            };
        }
        controller.$inject = ['$element', '$timeout'];
        return directive;
    }
};